<template>
  <div class="fraud">
  <!-- 涉嫌欺诈-步骤指引 -->
  <div class="fraud-guide">
    <div class="fraud-guide-title">请选择举报原因</div>
  </div>
    <!-- 单选框-损失金额原因 -->
    <div class="reason-scroll" >
      <RadioGroup class="reason-radiolist" v-model="radio" >
        <Radio
          class="reason-radioitem"
          v-for="(item, index) in reasonList"
          :key="index"
          :name="item.reasonId"
          @click="radioClick(item)"
          >{{ item.reason }}
        </Radio>
      </RadioGroup>
      <!-- 损失金额提交页 -->
      <div v-if="hasLossMoney">
        <section class="process-desc">
          <z-cell-group>
            <header class="process-header">金钱损失（元）</header>
            <z-line-input
              id="desc"
              class="input-loss-money"
              v-model="moneyNum"
              placeholder="请填写数字金额（必填）"
              @blur="txtBoxBlur"
              ref="inputLossMoney"
              type="number"
            />
            <header class="process-header">首次支付时间</header>
            <z-line-input
              id="desc"
              v-model="firstPayTime"
              readonly
              placeholder="请选择交易首次支付或转账时间"
            />
            <!-- input遮罩 -->
            <div class="input-mask" @click="toggleTimePicker"></div>
          </z-cell-group>
          <z-popup v-model="showTimePicker" position="bottom">
            <z-datetime-picker
              v-model="firstPayTimeObj"
              type="datetime"
              @confirm="handleDataTimeConfirm"
              @cancel="handleDataTimeCancel"
              :max-date="maxDate"
            />
          </z-popup>
        </section>
        <section class="snapshot-proof">
          <header class="process-header">
            资损凭证<span class="process-example" @click="JumpToExample">查看示例</span>
          </header>
          <div class="snapshot-tip">如：转账截图、收据等。上传凭证，会帮小熊更快定位及处理问题（必填，最多上传4张)</div>
          <div class="upload-area">
            <z-upload
              v-model="imageFiles"
              accept="image/*"
              :process-file="processFile"
              :max="4"
              btnUploadInfo="上传图片"
            />
          </div>
        </section>
      </div>
    </div>

    <z-button-group>
      <z-button @click="nextStep" type="primary" :disabled="buttonDisabled">下一步</z-button>
    </z-button-group>
  </div>
</template>

<script>
import { lego } from '@zz-common/lego'
import compress from '@zz-common/zz-ui/lib/utils/image'
import { Radio, RadioGroup, LineInput, CellGroup, Popup, DatetimePicker, Upload, Button, ButtonGroup } from '@zz-common/zz-ui'
import { searchReasonList } from '../logic'
import { getCookie } from '../../../lib/utils'
export default {
  name: 'FraudComp',
  components: {
    Radio,
    RadioGroup,
    zLineInput: LineInput,
    zCellGroup: CellGroup,
    zPopup: Popup,
    ZDatetimePicker: DatetimePicker,
    ZUpload: Upload,
    zButton: Button,
    zButtonGroup: ButtonGroup
  },
  inject:
  {
    sharedData: {
      default: () => {}
    },
    submitData: {
      default: () => {}
    },
    mergeSubmitData: {},
    setRadioChooseEvidence: {}
  },
  data() {
    return {
      showFraudGuide: true, //引导页显隐
      hasLossMoney: false, //是否损失前款
      radio: '', //单选框结果
      curReason: {}, //当前原因
      moneyNum: '', //金额
      firstPayTime: '', //首次支付时间
      firstPayTimeObj: new Date(),
      maxDate: new Date(), // 最大时间为当前时间
      showTimePicker: false, // 首次支付时间，时间选择flag
      imageFiles: [], //上传图片,
      reasonId: this.submitData.reasonId //本地化一下，使用本地的
    }
  },
  computed: {
    //原因列表
    reasonList() {
      return searchReasonList(this.sharedData.reasonList, this.reasonId)
    },
    //按钮状态
    buttonDisabled() {
      if (this.radio == '201') {
        return !this.moneyNum || !this.firstPayTime || !this.imageFiles.every(item => item.status == 'success') || !this.imageFiles.length
      } else {
        return !this.radio
      }
    }
  },
  methods: {
    processFile(file, next) {
      // 开启图片压缩，提高上传的速度，同时修正拍摄的图片方向和显示的问题
      compress(file, {
        compress: true
      }, next)
    },
    //聚焦处理
    txtBoxBlur() {
      setTimeout(() => {
        document.body.scrollTop = document.body.scrollHeight
      }, 100)
    },
    toggleTimePicker() {
      this.showTimePicker = true
    },
    //确认时间
    handleDataTimeConfirm(val) {
      // const stamp = val.getTime()
      this.firstPayTimeObj = val
      this.firstPayTime = val.format('YYYY-MM-DD HH:mm')
      // console.log('handleDataTimeChange', val, stamp)
      this.showTimePicker = false
    },
    //取消时间
    handleDataTimeCancel() {
      this.showTimePicker = false
    },
    //单选框点击
    radioClick(item) {
      this.curReason = item
      this.radio = item.reasonId
      if (item.reasonId == '201') {
        this.hasLossMoney = true
      } else {
        this.hasLossMoney = false
      }
    },
    //合并数据，下一步
    nextStep() {
      console.log(this.imageFiles)
      this.mergeSubmitData({
        reasonId: this.curReason.reasonId,
        moneyLoss: this.moneyNum,
        moneyLossPics: this.imageFiles.map(item => { return item.url }).join('|'),
        firstPayTime: this.firstPayTime
      })
      this.setRadioChooseEvidence(this.curReason.evidenceChoose)
      this.$router.push('/reportreason/chooseevidence')
    },
    //路由跳转
    JumpToExample() {
      this.$router.push('/reportreason/uploadExample')
    },
    clickGuide() {
      lego.send({
        pagetype: 'ZZUP_REPORT_REASON',
        actiontype: 'CLICK_FRAUD',
        backup: {
          from: this.sharedData.from,
          uid: getCookie('uid'),
          msg: '1'
        }
      })
      this.$router.push('/reportreason/uploadGuide')
    },
    clickHandle() {
      lego.send({
        pagetype: 'ZZUP_REPORT_REASON',
        actiontype: 'CLICK_FRAUD',
        backup: {
          from: this.sharedData.from,
          uid: getCookie('uid'),
          msg: '2'
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>